import React from 'react';
import { InsurancePlan } from './InsurancePlan';
import { DentalInsurancePlan } from '@benzinga/content-manager';

interface InsurancePlanProp {
  plans: DentalInsurancePlan[];
  quoteRequestId: string;
}

export const InsurancePlans: React.FC<InsurancePlanProp> = ({ plans, quoteRequestId }) => {
  return (
    <div className="plan-list-wrapper" style={{ marginTop: '12px' }}>
      <div className="member-details-item">
        {plans?.map((plan, i) => (
          <InsurancePlan key={i} plan={plan} quoteRequestId={quoteRequestId} />
        ))}
      </div>
    </div>
  );
};
